import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { ItemPair } from "../firestore/Types/UI/ItemPair";

export function AutoComplete({ Items, setValue, defaultValue = undefined, value = undefined }: { Items: ItemPair[], setValue: (value: string) => void, defaultValue?: string, value?: string }) {

    const handleOnSearch = (text: string, results: ItemPair[]) => {
        for (const result of results) {
            if (result.Value === text) {
                setValue(result.Value);
                return;
            }
      };
    };

    const handleOnSelect = (item: ItemPair) => {
        setValue(item.Value);
    };

    return (
        <ReactSearchAutocomplete
                        className="w-full col-span-3"
                        items={Items.map((item, index) => ({ id: index, Text: item.Text, Value: item.Value })) as { id: number, Text: string, Value: string }[]} // Data for the search list
                        fuseOptions={{ keys: ["Text"] }} // Search on both fields
                        resultStringKeyName={"Text"} // String to display in the results
                        placeholder={defaultValue}
                        inputSearchString={value}
                        onClear={() => setValue("")}
                        onSearch={handleOnSearch}
                        onSelect={handleOnSelect}
                        showIcon={false}
                        styling={{
                            height: "30px",
                            border: "1px solid darkgray",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "lightgray",
                            color: "black",
                            fontSize: "12px",
                            iconColor: "gray",
                            lineColor: "lightgray",
                            placeholderColor: "black",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 2,
                        }}
                        />
    )
}